import axios from 'axios';

export const sendIndividualSMS = async (to, message) => {
    try {
      const url = '/send-individual-sms';

      console.log('Sending request to:', url);
      const response = await axios.post(url, { to, message });
      return response.data;
    } catch (error) {
      console.error('Error sending individual SMS:', error);
      throw error;
    }
  };
  
  export const sendBulkSMS = async (recipients, message) => {
    try {
      // const url = 'http://localhost:8001/api/send-bulk-sms';
          const url = '/send-bulk-sms';
      console.log('Sending request to:', url);
      const response = await axios.post(url, { recipients, message });
      return response.data;
    } catch (error) {
      console.error('Error sending bulk SMS:', error);
      throw error;
    }
  };